module.exports = __webpack_public_path__ + "static/media/808-trimmed.9bb94354.wav";